import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import './AssignFtoToPhase.scss'
import classNames from 'classnames';
import {FormGroup, Input, Label} from "reactstrap";
import AvailableFtoCard from "./AvailableFtoCard";
import oitsActions from "../../store/oits/action-creators/index";
import departmentSettingsSelectors from "../../store/department-settings/selectors";

class AssignFtoToPhase extends Component {

  constructor(props) {
    super(props);
    let opened = this.props.trainingPhases.find(tp => tp.status === 'opened')
    this.state = {
      selectedPhaseGuid: opened? opened.trainingPhaseGuid: null,
      filterByName: '',
      filteredFtos: this.props.ftos? this.props.ftos: [],
    }

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ftos) {
      this.setState({ filteredFtos: nextProps.ftos });
    }
  }

  // ------------
  // Methods
  // ------------

  selectPhase(tp) {
    this.setState({
      selectedPhaseGuid: tp.trainingPhaseGuid
    })
  }

  filterByName(characters) {
    const filteredFtos = this.props.ftos.filter((fto) => {
      return fto
        .getFullNameReversed()
        .toLowerCase()
        .includes(characters.toLowerCase());
    });
    this.setState({ filteredFtos, filterByName: characters });
  }

  assignFto(ftoGuid) {
    const formData = {
      ftoGuid,
      trainingPhaseGuid: this.state.selectedPhaseGuid,
    };
    this.props.assignFtoToPhase(formData);
  }

  // ------------
  // Computed
  // ------------

  get openPhases() {
    return this.props.trainingPhases.filter(tp => tp.status !== 'completed')
  }

  get selectedPhase() {
    return this.props.trainingPhases.find(tp => tp.trainingPhaseGuid === this.state.selectedPhaseGuid);
  }

  render() {
    return (
      <div className="assign-fto-to-phase">
        <div className="training-phases">
          {this.openPhases.map(tp => (
            <button key={tp.trainingPhaseGuid} className={classNames('button', {
              primary: this.state.selectedPhaseGuid === tp.trainingPhaseGuid,
              default: this.state.selectedPhaseGuid !== tp.trainingPhaseGuid,
            })}
              onClick={() => this.selectPhase(tp)}>
              <span>{tp.header}</span>
              <span className="phase-status">{tp.status}</span>
            </button>
          ))}
        </div>
        { this.selectedPhase && this.selectedPhase.fto && (
          <div className="assigned-fto">
            <div className="heading">Assigned Fto</div>
            <div className="fto-name">{this.selectedPhase.fto.firstName} {this.selectedPhase.fto.lastName}</div>
            <div className="unassign">
              <button className="button secondary" onClick={() => this.props.unassignFtoFromPhase(this.selectedPhase.trainingPhaseGuid)}>
                <i className="fa fa-minus-circle" />
                <span>Unassign {this.props.ftoShortLabel}</span>
              </button>
            </div>
          </div>
        )}
        { (!this.selectedPhase || !this.selectedPhase.fto) && (
          <Fragment>
            <form className="column">
              <FormGroup>
                <Label for="filterByName">Filter by Name:</Label>
                <Input
                  disabled={!this.props.ftos}
                  onChange={event => this.filterByName(event.target.value)}
                  name="filterByName"
                  placeholder={`Search ${this.props.ftoShortLabel}`}
                  value={this.state.filterByName}
                />
              </FormGroup>
            </form>
            {this.state.filteredFtos.map(fto => (
              <AvailableFtoCard
                fto={fto}
                key={fto.guid}
                onAssign={ftoGuid => this.assignFto(ftoGuid)}
              />
            ))}
          </Fragment>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ftos: state.ftos.list,
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    unassignFtoFromPhase: (phaseGuid) => {
      return dispatch(oitsActions.unassignFtoFromPhase(phaseGuid));
    },
    assignFtoToPhase: (formData) => {
      return dispatch(oitsActions.assignFtoToPhase(formData));
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignFtoToPhase);
